/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One item of a lesson reorder request: the lesson and its new position.
 * @export
 * @interface LessonOrderItem
 */
export interface LessonOrderItem {
    /**
     * 
     * @type {string}
     * @memberof LessonOrderItem
     */
    lesson_id: string;
    /**
     * 
     * @type {number}
     * @memberof LessonOrderItem
     */
    order: number;
}

/**
 * Check if a given object implements the LessonOrderItem interface.
 */
export function instanceOfLessonOrderItem(value: object): value is LessonOrderItem {
    if (!('lesson_id' in value) || value['lesson_id'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function LessonOrderItemFromJSON(json: any): LessonOrderItem {
    return LessonOrderItemFromJSONTyped(json, false);
}

export function LessonOrderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessonOrderItem {
    if (json == null) {
        return json;
    }
    return {
        
        'lesson_id': json['lesson_id'],
        'order': json['order'],
    };
}

export function LessonOrderItemToJSON(json: any): LessonOrderItem {
    return LessonOrderItemToJSONTyped(json, false);
}

export function LessonOrderItemToJSONTyped(value?: LessonOrderItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lesson_id': value['lesson_id'],
        'order': value['order'],
    };
}

